import { RadioGroup, type RadioGroupProps } from '@sapphire-react/core';
import { ReactNode } from 'react';
import { Controller } from 'react-hook-form';
import { useSapphireMedia } from '../hooks';
import { FormFieldProps } from '../types';

type Props = Omit<RadioGroupProps, 'value| name'> & {
  name: string;
  onChange?: (name: string) => void;
} & FormFieldProps & {
    children: ReactNode;
  };

export function RadioGroupField(props: Props) {
  const { control, name, defaultValue, children, rules, onChange, ...rest } =
    props;
  const { isExtraSmall, isSmall } = useSapphireMedia();

  return (
    <Controller
      control={control}
      name={name}
      rules={rules}
      defaultValue={defaultValue || undefined}
      render={({ field: { ref: _ref, ...field }, fieldState: { error } }) => (
        <RadioGroup
          {...field}
          {...rest}
          size={isExtraSmall || isSmall ? 'md' : 'lg'}
          id={field.name}
          value={field.value}
          error={error?.message}
          data-test-id={`${name}-radio-group`}
          onChange={(value) => {
            field.onChange(value);
            onChange?.(value);
          }}
        >
          {children}
        </RadioGroup>
      )}
    />
  );
}
